export default __webpack_public_path__ + "static/media/cars.10673560.gif";